import { AcceptanceDocumentsKeyType } from '../../keys';

const acceptanceDocumentsKeys: AcceptanceDocumentsKeyType = {
  accepting: 'Принятие...',
  actionRequired: 'Требуется действие',
  confirmConsent: 'Я подтверждаю, что прочитал(-а) и соглашаюсь с',
  dearUser: 'Уважаемый пользователь,',
  notReadyToAccept: 'Не готовы принять?',
  restrictedAccessNotice:
    'Доступ к вашей учетной записи ограничен, пока вы не примете обновленные документы.',
  termsUpdateDescription:
    'В связи с обновлением юридического лица, управляющего платформой Archivizer, документы, регулирующие использование платформы, были обновлены. Чтобы продолжить использование своей учетной записи, пожалуйста, ознакомьтесь и примите обновленные документы.',
  updatedDocuments: 'обновленными документами',
  updatedTerms: 'Обновленные условия'
};

export default acceptanceDocumentsKeys;
